import { createSelector } from 'reselect';
import { denormalize } from 'denormalizr';

import { video as videoSchema } from 'shared/schemas';
import { isUploaded } from 'shared/utils/video-helpers/statuses';
import { isVideoFromComputer } from 'shared/ui-selectors/video/video-origin';


function withDealInfoFromSettings(state, video) {
  if (!video) {
    return video;
  }

  // TODO: move to entities reducer
  video.dealInfo = _.isEmpty(video.dealInfo) ? _.get(state, 'vodSettings.dealInfo') : video.dealInfo;
  video.memberOnly = (_.isUndefined(video.memberOnly)) ? _.get(state, 'vodSettings.memberOnly') : video.memberOnly;
  return video;
}

function getStateVideosGroupedByIds(state) {
  return state.entities.videos;
}


export function isFetching(state) {
  return state.videos.activeRequests !== 0;
}

export function getVideoIds(state) {
  return state.videos.ids;
}

export function getVideoById(state, videoId) {
  return state.entities.videos[videoId];
}

export const getVideoWithDealInfoFromSettings = createSelector(
  [
    state => state,
    getVideoById,
  ],
  (state, videoData) =>
    withDealInfoFromSettings(state, videoData),
);

/**
 * @param state
 * @param videoId {String}
 * @returns {Object} video
 */
export const getVideoWithChannelDataById = createSelector(
  [
    state => state,
    getVideoById,
  ],
  (state, videoData) =>
    // TODO remove denormalize. Used to add channel data to usedInLists
    withDealInfoFromSettings(state, denormalize(videoData, state.entities, videoSchema)),
);

/**
 * @param state
 * @returns {Object} {id: video}
 */
export const getVideosGroupedByIds = createSelector(
  [
    state => state,
    getStateVideosGroupedByIds,
  ],
  (state, videosByIds) =>
    _.mapValues(videosByIds, _.partial(withDealInfoFromSettings, state)),
);


/**
 * @param state
 * @param ids {String[]}
 * @returns {Object[]} videos list
 */
export const getVideosByIds = createSelector(
  [
    getVideosGroupedByIds,
    (state, ids) => ids,
  ],
  _.pick,
);

/**
 * @param state
 * @param ids {String[]}
 * @param currentVideoId {String}
 * @returns {Object[]} videos list
 */
export const getVideosByIdsWithoutCurrent = createSelector(
  [
    getVideosByIds,
    (state, ids, currentVideoId) => currentVideoId,
  ],
  _.omit,
);


/**
 * @param state
 * @param props {String[]}
 * @returns {Object} {id: videoProps}
 */
export const getVideosGroupedByIdsProps = createSelector(
  [
    getVideosGroupedByIds,
    (state, props) => props,
  ],
  (videosByIds, props = []) =>
    _.mapValues(videosByIds, video => _.pick(video, ['id', ...props])),
);


/**
 * @param state
 * @returns {Boolean}
 */
export const areAllVideosUploaded = createSelector(
  [
    getStateVideosGroupedByIds,
    getVideoIds,
  ],
  (videoByIds, ids) => (
    !_.isEmpty(videoByIds) && _.every(ids, id => isUploaded(videoByIds[id]))
  ),
);


/**
 * @param state
 * @returns {Object[]} videos list
 */
export const getVideosFromComputer = createSelector(
  [
    getVideosGroupedByIds,
  ],
  videoByIds => _.filter(videoByIds, ({ videoSource }) => isVideoFromComputer(videoSource)),
);


/**
 * @param state
 * @returns {Boolean}
 */
export const hasVideosFromComputer = createSelector(
  [
    getVideosFromComputer,
  ],
  uploadedVideosDataList => Boolean(uploadedVideosDataList.length),
);



// WEBPACK FOOTER //
// ./src/shared/selectors/videos.js